<template>
    <header class="main-header">
        <!-- Header Navbar -->
        <nav class="navbar navbar-expand" :class="appLayout.nav">
            <!-- Sidebar toggle button-->
            <ul class="navbar-nav">
                <li class="nav-item"><a class="nav-link" data-widget="pushmenu" href="#"><i class="fa fa-bars"></i></a>
                </li>
            </ul>
            <ul class="navbar-nav ml-auto">
                <li class="d-none d-md-block nav-item dropdown user user-menu">
                    <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
                        <img :src="user.avatar" class="user-image" alt="User Image">
                        <span class="hidden-xs">{{ user.nome }}</span>
                    </a>
                    <ul class="dropdown-menu">
                        <!-- User image -->
                        <li class="user-header">
                            <img :src="user.avatar" class="img-circle">
                            <p style="text-overflow: ellipsis;width: 250px;overflow: hidden; white-space: nowrap">
                                {{ user.nome }}
                                <small>{{$t('words.member')}} {{ registered_at }}</small>
                            </p>
                        </li>
                        <li v-if="auth_user.ambiente == 'A'" class="user-body">
                            <div class="row">
                                <div class="col-xs-12 text-center">
                                    <router-link to="/parametros">
                                        <i class="fa fa-gear"></i>
                                        {{$t('words.company_settings') }}
                                    </router-link>
                                </div>
                            </div>
                        </li>
                        <hr v-else class="m-0">
                        <li>
                            <div class="row text-primary m-0 p-2 justify-content-between">
                                <router-link to="/dicas" target="_blank" class="col-5 text-underline">Termos</router-link>
                                <a class="col-5 text-right"
                                    href="https://www.youtube.com/channel/UCZC-ve4TCMkUq4x9qiYnOfQ" target="_blank">
                                    <i class="fa fa-youtube-play text-danger"></i> <span class="px-1 text-underline">Duvidas</span>
                                </a>
                            </div>
                        </li>
                        <!-- Menu Footer-->
                        <li class="user-footer">
                            <div class="float-left">
                                <router-link :to="{ name: 'profile' }" class="btn btn-default">
                                    <i class="fa fa-user"></i> {{$t('words.user_settings')}}</router-link>
                            </div>
                            <div class="float-right">
                                <button type="button" @click="signOut" class="btn btn-default">
                                    {{$t('words.log_out')}} <i class="fa fa-sign-out"></i> </button>
                            </div>
                        </li>
                    </ul>
                </li>
                <li class="d-none d-md-block nav-item">
                    <a class="nav-link" data-widget="fullscreen" href="#" role="button">
                        <i class="fa fa-arrows-alt"></i>
                    </a>
                </li>
                <li @click="signOut" class="nav-item">
                    <a href="#" role="button" class="nav-link">
                        <i class="fa fa-sign-out"></i> {{$t('words.log_out')}}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-widget="control-sidebar" data-slide="true" href="#" role="button">
                        <i class="fa fa-th-large"></i>
                    </a>
                </li>
            </ul>

        </nav>
    </header>
</template>

<script>
    /*eslint no-mixed-spaces-and-tabs: [2, "smart-tabs"]*/
    import moment from 'moment';
    export default {
        props: {
            user: Object
        },
        computed: {
            registered_at() {
                return moment(this.user.created_at).format('MMM/YYYY');
            },
        },
        methods: {
            signOut() {
                $('#ModalLogout').modal('toggle');
            },
            showNotification(notification, id) {
                if (!notification.is_previewed)
                    this.$store
                    .dispatch('previewNotification', notification.id)
                    .then(response => {
                        response.index = id;
                        this.$store.dispatch('setNotification', response);
                    });

            }
        }
    };
</script>

<style scoped>
    ul.dropdown-menu {
        cursor: default !important;
    }

    .text-underline {
        text-decoration: underline;
    }
</style>